// iOS Safari does not shrink dvh/vh units when the on-screen keyboard opens —
// only the visual viewport gets smaller, so a min-height: 100dvh layout keeps
// the footer hidden behind the keyboard. Mirroring the visual viewport height
// into a CSS custom property lets the stylesheet size the layout to the space
// actually visible above the keyboard (with 100dvh as the no-JS fallback).
export const initViewportHeightTracking = () => {
  const viewport = window.visualViewport;
  if (!viewport) return;

  const updateViewportHeight = () => {
    document.documentElement.style.setProperty(
      '--cwa-viewport-height',
      `${Math.round(viewport.height)}px`,
    );
  };

  updateViewportHeight();
  viewport.addEventListener('resize', updateViewportHeight);
};
